export default {
  methods: {
    utilityComponents () {
      // HREF
      if (!AFRAME.components.href) {
        AFRAME.registerComponent('href', {
          schema: { default: '' },
          update (oldData) {
            const url = this.data
            this.el.addEventListener('click', function () {
              window.location.href = url
            })
          },
          remove () {
            delete AFRAME.components.href
          }
        })
      }
      // TEXT PADDING
      if (!AFRAME.components.textpadding) {
        AFRAME.registerComponent('textpadding', {
          schema: {
            addPadding: { type: 'boolean', default: false },
            padding: { type: 'number', default: 0.01 }
          },
          init () {
            const data = this.data
            this.el.setAttribute('textpadding', 'addPadding: false')
          },
          update (oldData) {
            const data = this.data
            const el = this.el

            if (Object.keys(data).length === 0) {
              return
            }

            /**
             * If the flag is true add padding to the plane
             */
            if (data.addPadding === true) {
              /**
               * Set padding using the provided padding value
               */
              el.getObject3D('mesh').geometry = new THREE.PlaneGeometry(
                el.components.geometry.data.width +
                  el.components.textpadding.data.padding,
                el.components.geometry.data.height +
                  el.components.textpadding.data.padding
              )

              /**
               * Remove textpadding attribute so that it padding can be
               * changed in the future by adding the attribute again
               */
              this.el.removeAttribute('textpadding')
            }
          },
          tick (time, delta) {
            const data = this.data
            const el = this.el

            /**
             * Check if the width is not NaN, padding hasn't already been
             * added i.e `addPadding` schema attribute is false and that the
             * plane's width is same as the text's width which means padding
             * hasn't been added yet
             */

            if (
              el.components.geometry.data.width != NaN &&
              el.components.textpadding.data.addPadding === false &&
              el.components.geometry.data.width == el.components.text.data.width
            ) {
              // Set the schema attribute `addPadding` to true so that the padding can be added
              el.setAttribute('textpadding', 'addPadding: true')
            }
          }
        })
      }

      if (!AFRAME.components.clickablearea) {
        AFRAME.registerComponent('clickablearea', {
          schema: {
            sister: { type: 'string', default: '' }
          },
          init () {
            const data = this.data
          },
          update (oldData) {
            const data = this.data
            const el = this.el

            if (Object.keys(data).length === 0) {
              return
            }

            /**
             * Set clickable area using the sister's size value
             */
            if (this.data.sister !== '') {
              const sisterElement = document.querySelector(
                '[' + this.data.sister + ']'
              )
              const sisterGeometry = sisterElement.getObject3D('mesh').geometry
              el.components.geometry.data.width = sisterGeometry.data.width
              el.components.geometry.data.height = sisterGeometry.data.height
            }
          },
          tick (time, delta) {}
        })
      }

      // SPIN
      if (!AFRAME.components.spin) {
        AFRAME.registerComponent('spin', {
          schema: {
            speed: { default: 2000 },
            direction: { default: 'normal' },
            axis: { default: 'y' }
          },
          init () {
            const { el } = this
            el.setAttribute('animation__spin', {
              property: `object3D.rotation.${this.data.axis}`,
              from: 0,
              to: 360,
              dur: this.data.speed,
              dir: this.data.direction,
              loop: true,
              easing: 'linear'
            })
          }
        })
      }

      // NOT WORKING YET
      if (!AFRAME.shaders.custom) {
        AFRAME.registerShader('custom', {
          schema: {
            emissive: { default: '0x123fff' },
            emissiveIntensity: { default: 1 },
            wireframe: { default: false }
          }
        })
      }
    }
  }
}
